var exports = {
  "Pf": "x804f0401--1f3f2a--label",
  "vu": "x804f0401--1f3f2a--active",
  "DD": "x804f0401--1f3f2a--title",
};

module.exports = exports;
